import React from 'react';
import { Alert, Form, Select } from 'antd';
import { CreditCardOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if (formPlugin.formData.type !== "COMPLEX") {
                if (props.remove) {
                    props.remove()
                }
                return null
            }

            const paiementMethods = formPlugin.formData?.paiementMethods || []

            if ((props.isPreviewMode || props.readOnly) && paiementMethods.length === 0) {
                return null
            }

            if (paiementMethods.length === 0) {
                return (
                    <Alert
                        showIcon
                        type={"warning"}
                        message={t`Veuillez Ajouter des Moyens de Paiements.`}
                    />
                )
            }

            const { data } = props

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            const finalName = "__paiementMethod"
            return (
                <Form.Item
                    label={`${data.label || t`Moyen de Paiement`} :`}
                    name={finalName}
                    rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                    tooltip={tooltip}
                >
                    <Select>
                        <Select.Option value={"En Ligne"}>
                            <Trans>En Ligne</Trans>
                        </Select.Option>
                        {paiementMethods.map(i => {
                            return (
                                <Select.Option value={i}>
                                    {i}
                                </Select.Option>
                            )
                        })}
                    </Select>
                </Form.Item>
            )
        },
        namespace: namespace,
        id: 'form-paiement-method' + namespace,
        title: t`Moyen de Paiement`,
        description: t`Élément de formulaire utilisable.`,
        icon: <CreditCardOutlined />,
        iconColor: "#8E44AD",
        hideInMenu: formPlugin.formData.type !== "COMPLEX",
        version: 1,
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },

                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                }
            },
        },
    }
}
